import { render, staticRenderFns } from "./TableMenuCustomer.vue?vue&type=template&id=a2461d3e&scoped=true&"
import script from "./TableMenuCustomer.vue?vue&type=script&lang=js&"
export * from "./TableMenuCustomer.vue?vue&type=script&lang=js&"
import style0 from "./TableMenuCustomer.vue?vue&type=style&index=0&id=a2461d3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2461d3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemAvatar,VListItemContent,VListItemTitle,VMenu})
